export const GENDER_FILTER = 'GENDER_FILTER'
export const APPLIED_GENDER_FILTER = 'APPLIED_GENDER_FILTER_DATA'
export const APPLIED_COLOR_FILTER = 'APPLIED_COLOR_FILTER_DATA'
export const APPLIED_BRAND_FILTER = 'APPLIED_BRAND_FILTER'
export const APPLIED_FADMONTH_FILTER = 'APPLIED_FADMONTH_FILTER'
export const APPLIED_FADYEAR_FILTER = 'APPLIED_FADYEAR_FILTER'
export const APPLIED_PERFORMANNCE_BUCKET_FILTER = 'APPLIED_PERFORMANNCE_BUCKET_FILTER'
export const APPLIED_PARENT_JSON = 'APPLIED_PARENT_JSON'
export const SAVED_LIKED_STYLE = 'SAVED_LIKED_STYLE'